"use client";

import { useEffect, useId } from "react";
const activeInstances = new Set();
const originalStyles = {};

/**
 * A utility that prevents the body from scrolling. This is useful for modals and other components that need to prevent the page from scrolling in the background but allow the component to still scroll.
 * @param {object} props - The component props
 * @param {boolean} [props.active] - Boolean flag to indicate if the body lock is active
 * @returns {React.ReactNode} The BodyLock element
 */
const BodyLock = ({
  active
}) => {
  const id = useId();
  useEffect(() => {
    const setup = () => {
      if (activeInstances.size === 0) {
        originalStyles.scrollX = globalThis.scrollX;
        originalStyles.scrollY = globalThis.scrollY;
        originalStyles.position = document.body.style.position;
        originalStyles.width = document.body.style.width;
        originalStyles.insetBlockStart = document.body.style.insetBlockStart;
        originalStyles.insetInlineStart = document.body.style.insetInlineStart;
        document.body.style.position = "fixed";
        document.body.style.width = "100%";
        document.body.style.insetBlockStart = `-${originalStyles.scrollY}px`;
        document.body.style.insetInlineStart = `-${Math.abs(originalStyles.scrollX)}px`;
      }
      activeInstances.add(id);
    };
    const cleanup = () => {
      activeInstances.delete(id);
      if (activeInstances.size === 0 && Object.keys(originalStyles).length !== 0) {
        document.body.style.position = originalStyles.position;
        document.body.style.width = originalStyles.width;
        document.body.style.insetBlockStart = originalStyles.insetBlockStart;
        document.body.style.insetInlineStart = originalStyles.insetInlineStart;
        try {
          globalThis.scrollTo(originalStyles.scrollX, originalStyles.scrollY);
        } catch (error) {
          error; //Add this try catch because `JSDOM` throws an error that `scrollTo` is not implemented.
        }
        for (const style in originalStyles) {
          delete originalStyles[style];
        }
      }
    };
    if (active) {
      setup();
    } else {
      cleanup();
    }
    return cleanup;
  }, [active, id]);
  return null;
};
export default BodyLock;